/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import parse from 'html-react-parser';
import { formatDate } from '../../scripts/date-formatting';
import Image from '../image/Image';
import SliderWrapper from '../slider-wrapper/SliderWrapper';

export interface IArticle {
  url: string;
  title: string;
  p_date: string;
  image: string;
  readtime: number;
  category: {
    cat: string;
  };
}
type ArticleProps = {
  content: IArticle[];
  articlesPerSlider?: number;
  className?: string;
};

export default class ArticlesSlider extends React.Component<ArticleProps> {
  content = this.splitArticlesByChunks(this.props.content, this.props.articlesPerSlider || 3);

  splitArticlesByChunks(array: IArticle[], n: number) {
    const cache = [];
    const tmp = [...array];
    while (tmp.length) cache.push(tmp.splice(0, n));
    return cache;
  }

  render() {
    const formatCategory = (cat: string) => {
      const splitStr = cat.replace(/-/g, ' ').toLowerCase().split(' ');
      for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    };
    const returnDate = (article: IArticle) => {
      return `${article.readtime} min &#8226; ${formatDate(article.p_date)}`;
    };
    return (
      <div className="row gx-lg-6 gx-xl-7">
        <div className={`${this.props.className || ''} col-12 px-lg-1`}>
          <SliderWrapper>
            {this.content.map((art, i) => (
              <React.Fragment key={`${i}-art-slider-wrp`}>
                {art.map((article: IArticle, index) => (
                  <div
                    className={`d-flex col article-wrapper justify-content-between px-lg-3 px-xl-4 position-relative ${index < art.length - 1 ? 'pb-3 pb-lg-0' : ''} ${index !== 0 ? 'pt-3 pt-lg-0' : ''}`}
                    key={`${index}-art-slider`}>
                    <div className="pe-3">
                      <h3 className="h5">
                        <a
                          href={article.url}
                          className="text-dark text-decoration-none stretched-link">
                          {article.title}
                        </a>
                      </h3>
                      <p className="text-gray w-100 body-text-xs">{parse(returnDate(article))}</p>
                      <span className="label label-blue p-1 mb-0 body-text-xs text-uppercase">
                        {formatCategory(article.category.cat)}
                      </span>
                    </div>
                    <Image
                      className="rounded-3 align-self-start d-block"
                      alt=""
                      src={article.image}
                      width="88"
                      height="88"
                      lazyLoading
                    />
                  </div>
                ))}
              </React.Fragment>
            ))}
          </SliderWrapper>
        </div>
      </div>
    );
  }
}
